import React from "react";
import { useController } from "react-hook-form";
import { Input } from "@/components/atoms/Input";
import { cn } from "@/utils/cn";
import { FormInputProps } from "./FormInput.types";

export const FormInput: React.FC<FormInputProps> = ({
    name,
    control,
    label,
    inputSize = "md",
    neumorph = false,
    variant = "default",
    disabled = false,
    className,
    onChange,
    ...rest
}) => {
    const {
        field: { onChange: onChangefield, value, ...fieldRest },
        fieldState: { error },
    } = useController({ name, control });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;

        if (rest.type === "number") {
            onChangefield(val === "" ? null : parseFloat(val));
        } else {
            onChangefield(val);
        }
        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div>
            <Input
                {...fieldRest}
                value={value ?? ""}
                onChange={handleChange}
                label={label}
                inputSize={inputSize}
                neumorph={neumorph}
                variant={variant}
                disabled={disabled}
                className={cn(
                    error && "border-red-500 focus:ring-red-500",
                    className
                )}
                {...rest}
            />
            {error && (
                <p className="text-red-600 text-sm mt-1" role="alert">
                    {error.message}
                </p>
            )}
        </div>
    );
};
